import type { TextStyle, ViewStyle } from 'react-native';

import { Button, ChevronDown, ChevronUp } from '../../../../../../../../../mads';
import { useI18n } from '../../../../../../../../../shared/I18n';
import { useFullScreenVJActive } from '../../../../../../../hooks/useFullScreenVJActive';

import { colors } from '@indeed/ifl-tokens/react-native';
import React from 'react';


export interface ShowHideButtonProps {
    isExpanded: boolean;
    onPress: () => void;
    sx?: ViewStyle;
    textSx?: TextStyle;
}

export const ShowHideButton = ({ isExpanded, onPress }: ShowHideButtonProps) => {
    const { gettext } = useI18n();
    const isFullScreenVJActive = useFullScreenVJActive();

    // For FullScreenVJ: no +/- prefix, different text
    const buttonText = isFullScreenVJActive
        ? isExpanded
            ? gettext('Show less')
            : gettext('Show more')
        : isExpanded
          ? gettext('- show less')
          : gettext('+ show more');

    if (isFullScreenVJActive) {
        return (
            <Button
                onPress={onPress}
                size="md"
                variant="secondary"
                iconAfter={
                    isExpanded ? (
                        <ChevronUp size="sm" color={colors.foregroundActionPrimary} />
                    ) : (
                        <ChevronDown size="sm" color={colors.foregroundActionPrimary} />
                    )
                }
            >
                {buttonText}
            </Button>
        );
    }

    return (
        <Button onPress={onPress} size="md" variant="text">
            {buttonText}
        </Button>
    );
};
